import { render, staticRenderFns } from "./FGC3.vue?vue&type=template&id=33222258&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./FGC3.vue?vue&type=script&lang=js&"
export * from "./FGC3.vue?vue&type=script&lang=js&"
import style0 from "./FGC3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports